import API_URLS from '../../config/BackendConfig';
import { getToken } from '../../utils/tokenUtils';
import { deleteRequest, getRequest, postRequest, putRequest } from '../../config/AxiosConfig';

const prodBaseUrl = API_URLS.PROD;
const CusBaseUrl = API_URLS.CUSTOMER
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Base request handler
const makeRequest = async (method, endpoint, payload) => {
  try {
    const config = {
      url: prodBaseUrl + endpoint,
      data: payload,
      headers: getAuthHeaders(),
    };
    
    const response = await method(config);
    return response;
  } catch (error) {
    console.error(`Error on ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};

// Super Key Services
export const createSuperKeyService = (payload) => 
  makeRequest(postRequest, "mobile-device/super-key/create", payload);

export const createSuperRefreshService = (payload) => 
  makeRequest(postRequest, "mobile-device/super-key/refresh", payload);

export const createSuperDeleteService = (payload) => 
  makeRequest(postRequest, "mobile-device/super-key/delete", payload);

// Key Services
export const createKeyService = (payload) => 
  makeRequest(postRequest, "mobile-device/key/create", payload);


export const getKeyService = (payload) => 
  makeRequest(postRequest,"mobile-device/key/get", payload);


export const createKeyRemoveService = (payload) => 
  makeRequest(postRequest, "mobile-device/key/remove", payload);

export const createKeyUnregisterService = (payload) => 
  makeRequest(postRequest, "mobile-device/key/unregister", payload);

export const createKeyRefreshService = (payload) => 
  makeRequest(postRequest, "mobile-device/key/refresh", payload);



// Key Control Services
export const createActionListService = (payload) =>     
  makeRequest(postRequest, "mobile-device/key-control/action-list", payload);

export const createActionApplyService = (payload) => 
  makeRequest(putRequest, "mobile-device/key-control/apply-action", payload);

export const createActionGetService = (payload) => 
  makeRequest(postRequest, "mobile-device/key-control/get-action", payload);

export const createActionStatusService = (payload) => 
  makeRequest(postRequest, "mobile-device/key-control/current-state-control", payload);



// Mobile Device Lock Report Service
export const MobileDeviceReportService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${CusBaseUrl}mobile-device/super-keys`,
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
      data: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
